if (!customElements.get("sticky-atc-machine-pdp")) {
  customElements.define(
    "sticky-atc-machine-pdp",
    class StickyAtcMachinePdp extends HTMLElement {
      constructor() {
        super();

        this.mainProdForm = document.querySelector("custom-toggle-product");
        this.copyOfMainProdForm = document.querySelector("custom-toggle-product").cloneNode(true);
        this.copyOfMainProdForm.classList.add("cloneNode");
        this.copyOfMainProdForm.querySelectorAll("input[type=radio]").forEach((i) => {
          i.id = i.id + "-clone";
        });
        this.copyOfMainProdForm.querySelectorAll("label").forEach((l) => {
          l.htmlFor = l.htmlFor + "-clone";
        });
        if (window.innerWidth <= 768) {
          this.mainFormContainer = [...document.querySelectorAll(".product-form__container")][0];
        } else {
          this.mainFormContainer = [...document.querySelectorAll(".product-form__container")][1];
        }

        if (this.mainProdForm) window.addEventListener("scroll", this.scrollStickyATC.bind(this));

        this.descriptionContainer = document.querySelector(
          ".product-description-container-outer.desktop-only"
        );
        this.descriptionContainerMobile = document.querySelector(
          ".product-description-container-outer.mobile-only"
        );
      }

      scrollStickyATC() {
        const headerBottom = document
          .querySelector("#shopify-section-header")
          .getBoundingClientRect().bottom;
        const productFormBottom = this.mainFormContainer.getBoundingClientRect().bottom;
        const descriptionContainerBottom =
          this.descriptionContainer?.getBoundingClientRect().bottom;

        const descriptionContainerMobileBottom =
          this.descriptionContainerMobile?.getBoundingClientRect().bottom;

        var formHeight, pickerHeight, marginHeight, stickyHeight;
        if (!this.classList.contains("stickyactive")) {
          formHeight = this.mainProdForm.offsetHeight;

          const formStyle = window.getComputedStyle(
            document.querySelector("custom-toggle-product")
          );
          marginHeight = parseFloat(formStyle.marginTop) + parseFloat(formStyle.marginBottom);
        } else {
          stickyHeight = this.offsetHeight;
        }

        if (window.innerWidth <= 768) {
          if (
            descriptionContainerMobileBottom <= headerBottom &&
            !this.classList.contains("stickyactive")
          ) {
            this.getFormContents(formHeight, marginHeight);
            this.classList.add("stickyactive");
          } else if (
            descriptionContainerMobileBottom > headerBottom &&
            this.classList.contains("stickyactive")
          ) {
            this.returnFormContents(stickyHeight);
            this.classList.remove("stickyactive");
          }
        } else {
          if (
            descriptionContainerBottom <= headerBottom &&
            !this.classList.contains("stickyactive")
          ) {
            this.getFormContents(formHeight, marginHeight);
            this.classList.add("stickyactive");
          } else if (
            descriptionContainerBottom > headerBottom &&
            this.classList.contains("stickyactive")
          ) {
            this.returnFormContents(stickyHeight);
            this.classList.remove("stickyactive");
          }
        }
      }

      async getFormContents(formHeight, marginHeight = 0) {
        if (formHeight && !isNaN(formHeight)) {
          this.mainFormContainer.style.height = `${formHeight + marginHeight}px`;
        }
        this.style.height = "auto";

        const oosCanadaProductIds = [];
        const oosUsaProductIds = [];
        const oosUkProductIds = [];

        for (const key in disableStickyATC) {
          if (disableStickyATC[key] === "no_CAN") {
            oosCanadaProductIds.push(key);
          } else if (disableStickyATC[key] === "no_UK") {
            oosUkProductIds.push(key);
          } else {
            oosUsaProductIds.push(key);
          }
        }

        if (oosCanadaProductIds.length > 0 && window.location.href.includes("/en-ca/")) {
          oosCanadaProductIds.forEach((productId) => {
            if (this.copyOfMainProdForm.querySelector(`form[data-productid="${productId}"]`)) {
              this.copyOfMainProdForm
                .querySelector(".product-form__buttons button[type='submit']")
                .setAttribute("disabled", true);

              this.copyOfMainProdForm
                .querySelector("variant-selects select")
                ?.setAttribute("disabled", true);
              this.copyOfMainProdForm.querySelector(
                ".product-form__buttons button[type='submit']"
              ).innerHTML = "SOLD OUT";
            }
          });
        }

        if (oosUkProductIds.length > 0 && window.location.href.includes("/en-gb/")) {
          oosUkProductIds.forEach((productId) => {
            if (this.copyOfMainProdForm.querySelector(`form[data-productid="${productId}"]`)) {
              this.copyOfMainProdForm
                .querySelector(".product-form__buttons button[type='submit']")
                .setAttribute("disabled", true);

              this.copyOfMainProdForm
                .querySelector("variant-selects select")
                ?.setAttribute("disabled", true);
              this.copyOfMainProdForm.querySelector(
                ".product-form__buttons button[type='submit']"
              ).innerHTML = "SOLD OUT";
            }
          });
        }

        if (
          oosUsaProductIds.length > 0 &&
          !window.location.href.includes("/en-ca/") &&
          !window.location.href.includes("/en-gb/")
        ) {
          oosUsaProductIds.forEach((productId) => {
            if (this.copyOfMainProdForm.querySelector(`form[data-productid="${productId}"]`)) {
              this.copyOfMainProdForm
                .querySelector(".product-form__buttons button[type='submit']")
                .setAttribute("disabled", true);
              this.copyOfMainProdForm.querySelector(
                ".product-form__buttons button[type='submit']"
              ).innerHTML = "SOLD OUT";
            }
          });
        }

        this.appendChild(this.copyOfMainProdForm);
      }

      returnFormContents(stickyHeight = 0) {
        this.mainFormContainer.style.height = "auto";
        this.style.height = `${stickyHeight}px`;

        this.removeChild(this.copyOfMainProdForm);
      }
    }
  );
}
